<template>
    <div style="height: 700px; padding: 20px; background-color: white; overflow-y: auto; border-radius: 10px; border: black solid 2px;">
        <v-card-title style="text-align: center;">Select Operation</v-card-title>

        <div class="part-row-headers">
            <div class="header row-one row">
                Sequence
            </div>
            <div class="header row-two row">
                Code
            </div>
            <div class="header row-three row">
                Description
            </div>
        </div>

        <div class="part-row" v-for="operation in currentAssemblyOperations" :key="operation.OpCode" @click="selectOperation(operation)">
            <div class="row-one row data">
                {{ operation.OprSeq }}
            </div>
            <div class="row-two row data">
                {{ operation.OpCode }}
            </div>
            <div class="row-three row data">
                {{ operation.OpDesc }}
            </div>
        </div>
    </div>
</template>

<script>
    import { useJobEntryStore } from "../../../../stores/ProjectManagement/JobEntry";
    import { mapWritableState } from "pinia";

    export default {
        name: "OperationSearch",
        emits: ["operationReceived"],
        computed: {
            ...mapWritableState(useJobEntryStore, [
                "currentAssemblyOperations",
            ])
        },
        props: {},
        data: () => ({
            search: "",
            partArray: []
        }),
        watch: {},
        created() {},
        mounted() {},
        methods: {
            selectOperation(operation) {
                this.$emit("operationReceived", operation);
                this.search = "";
            }
        },
    };
</script>

<style scoped>
    .part-row {
        display: flex;
        cursor: pointer;
        border-left: 1px solid gray;
        border-bottom: 1px solid gray;
    }
    .part-row-headers {
        display: flex;
        border-left: 1px solid gray;
        border-bottom: 1px solid gray;
    }
    .part-row:hover {
        background-color: rgb(211, 211, 211);
    }
    .header {
        text-align: center;
        font-weight: 600;
        border-bottom: 2px;
    }
    .row {
        border-bottom: 0; 
        border-top: 1px;
        border-right: 1px; 
        border-color: gray; 
        border-style: solid;
    }
    .data {
        font-size: 13px; 
        padding: 5px;
    }
    .row-one {
        border-left: 1px;
        width: 15%;
    }
    .row-two {
        width: 15%; 
        border-left: 0;
    }
    .row-three {
        width: 70%; 
        border-left: 0;
    }
</style>
